export const FORM_VIEW = Object.freeze({
  LOGIN: "login",
  REQUIRE_SIGNUP: "requireSignup",
  REGISTER: "register"
});
